import LikedMoviesContaner from "../componants/LikedMovies/LikedMoviesContanier";

export default function LikedMoviesPage() {
  return <LikedMoviesContaner />;
}
